import React from "react";
import { Route, Routes } from "react-router-dom";
import MainWorkPage from "./MainWorkPage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditWorkPage from "./AddEditWorkPage";
import WorkPageWrapper from "./WorkPageWrapper";
import PageNotFound from "../PageNotFound";
import ViewWorkPage from "./ViewWorkPage";

const WorkRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute
            element={<WorkPageWrapper Component={MainWorkPage} />}
          />
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute
            element={<WorkPageWrapper Component={AddEditWorkPage} />}
          />
        }
      />

      <Route
        path=":_id/edit"
        element={
          <ProtectedRoute
            element={<WorkPageWrapper Component={AddEditWorkPage} />}
          />
        }
      />
      <Route
        path=":_id"
        element={
          <ProtectedRoute
            element={<WorkPageWrapper Component={ViewWorkPage} />}
          />
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default WorkRouter;
